import { toastr } from 'react-redux-toastr';
import * as React from "react";
import { GoogleAnalyticsService } from 'src/share/services/ga';

export interface IGoogleStatisticsState {
  token: string
}

export const useGAToken = () => {
  const [token, setToken] = React.useState<string>('');
  React.useEffect(() => {
    getToken();
  }, []);
  const getToken = async () => {
    try {
      const accessToken = await GoogleAnalyticsService.getGAToken();
      setToken(accessToken);
    } catch (error) {
      toastr.error('Error', 'There was a problem accessing Google Analytics');
    }
  }
  return { token } as returned;
}

type returned = IGoogleStatisticsState;



// WEBPACK FOOTER //
// ./src/modules/GoogleStatistics/hooks/useGAToken.ts